import * as React from "react";

import { useBrand } from "../../hooks/useBrand";

/** The site's name as text (e.g. "Njoy", "CBM"), for places a hook can't reach. */
export const BrandName: React.FC = () => <>{useBrand().appName}</>;
